'use strict';

/**
 * Collections for diffrent albums
 *
 * @category   Model
 * @module     collection.album
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCollection = require('base/Colido.Collection');
var AlbumModel = require('../models/album');

var AlbumsPhotoboxCollection = ColidoCollection.extend({
    api: '/assets/photobox',

    name: 'collection:albums:photobox',

    model: AlbumModel,
});

module.exports = AlbumsPhotoboxCollection;